// extracted by mini-css-extract-plugin
export default {"deleteRightContent":"deleteAccount_deleteRightContent__btUfR","deleteCaution":"deleteAccount_deleteCaution__agwuo","passwordInput":"deleteAccount_passwordInput__O8E5u"};